import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { dict } from "@/i18n";
import { captureAttribution, pushEvent } from "@/attribution";

captureAttribution();
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Beach } from "@/components/Beach";
import { Location } from "@/components/Location";
import { Reviews } from "@/components/Reviews";
import { InstagramFeed } from "@/components/InstagramFeed";
import { Direct } from "@/components/Direct";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

const detectLang = () => "pt";

function App() {
    const [lang, setLang] = useState(detectLang);
    const t = dict[lang];

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        let done = false;
        const onScroll = () => {
            if (done) return;
            const max = document.documentElement.scrollHeight - window.innerHeight;
            if (max > 0 && window.scrollY / max >= 0.75) {
                done = true;
                pushEvent("scroll_75");
                window.removeEventListener("scroll", onScroll);
            }
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div className="App">
            <Nav t={t} lang={lang} setLang={setLang} />
            <main>
                <Hero t={t} />
                <Marquee items={t.marquee} />
                <Beach t={t} />
                <Location t={t} />
                <Reviews t={t} />
                <InstagramFeed t={t} />
                <Direct t={t} />
            </main>
            <Footer t={t} />
            <WhatsAppFloat t={t} />
        </div>
    );
}

export default App;
